<template>
  <CustomModal 
    :show="showModal"
    size="lg"
    @closeModal="$emit('close')">
    <template #modal-header>
      Contract History
    </template>
    <template #modal-body>
      <Full
        noCreateButton
        noSearchBar
        noPagination
        isServerSide
        :table="tables.histories"
        :pagination="paginations.client">
        <template v-slot:cell(balance)="{item, index}">
          {{ computeBalance(item, index) }}
        </template>
      </Full>
    </template>
    <template #modal-footer>
      <div class="button-footer">
        <!-- <SaveButton @click="$emit('save')" label="Add"/> -->
        <CloseButton @click="$emit('close')" class="ml-2 float-right"  />
      </div>
    </template>
  </CustomModal>
</template>
<script>
import tables from '../../helpers/tables'
import { formatNumber } from '../../helpers/forms'
import { ContractApi } from '../../mixins/api'
import { 
  CustomModal,
  CloseButton } from '../components'
import Full from '../components/Full'
export default {
  components: {
    CustomModal,
    Full,
    CloseButton
  },
  mixins: [ContractApi, tables],
  props: {
    contractId: {
      type: Number,
      default: null
    },
    billingId: {
      type: Number,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    monthId: Number,
    year: Number,
  },
  data() {
    return {
      tables: {
        histories: {
          isBusy: false,
          fields: [
            {
              key: 'referenceNo',
              label: 'REF NO',
              thClass: 'align-middle',
              thStyle: { width: '30%' },
            },
            {
              key: 'referenceDate',
              label: 'REF DATE',
              thClass: 'align-middle',
              thStyle: { width: '15%' },
            },
            {
              key: 'amount',
              label: 'DEBIT',
              thClass: 'align-middle text-right',
              tdClass: 'text-right',
              thStyle: { width: '17%' },
              formatter: (value) => {
                return formatNumber(value)
              }
            },
            {
              key: 'paymentAmount',
              label: 'CREDIT',
              thClass: 'align-middle text-right',
              tdClass: 'text-right',
              thStyle: { width: '17%' },
              formatter: (value) => {
                return formatNumber(value)
              }
            },
            {
              key: 'balance',
              label: 'BALANCE',
              thClass: 'align-middle text-right',
              tdClass: 'text-right',
              thStyle: { width: '20%' }
            },
          ],
          items: []
        }
      },
      filters: {
        client: {
          criteria: null
        }
      },
      paginations: {
        client: {
          from: 0,
          to: 0,
          totalRows: 0,
          page: 1,
          perPage: 10,
        },
      },
    }
  },
  methods: {
    loadHistory() {
      const { histories } = this.tables

      histories.isBusy = true
      const params = {
        year: this.year,
        monthId: this.monthId,
        billingId: this.billingId
      }

      this.getContractHistory(this.contractId, params)
      .then(({ data }) => {
        histories.items = data
        histories.isBusy = false
      })
    },
    computeBalance(item, index) {
      const { histories } = this.tables
      const history = index !== 0 ? histories.items[index - 1] : null
      const balance = history ? 
        history.balance : 0
      const rowBalance = Number(item.amount) - Number(item.paymentAmount)
      this.$set(item, 'balance', balance + rowBalance)
      
      return formatNumber(item.balance)
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        return newValue
      }
    }
  },
  watch: {
    showModal(value) {
      if (value) {
        this.loadHistory()
      }
    }
  }
}
</script>